import { type ReactElement } from 'react'
import { DashboardWidgetCard } from 'app/routes/dashboard_.$dashboardId/widgets'
import { type DashboardDataWithEditable, type DashboardWidget, type ReportDateRange } from '@terros/common'
import { Stack } from '@mantine/core'
import { useTranslation } from '@front/model'

type Props = {
  dashboard: DashboardDataWithEditable
  dateRange: ReportDateRange
  widgets: DashboardWidget[]
}

/**
 * The hustle dashboard pinned to the top of Home: the most specific
 * `home`-flagged dashboard that reaches the viewer. Its single widget renders
 * as a full-width card titled with the dashboard's name — the widget itself
 * has no user-set name, same as mobile.
 */
export function HustleFeedSection({ dashboard, dateRange, widgets }: Props): ReactElement {
  const { t } = useTranslation()

  return (
    <Stack gap='sm'>
      {widgets.map((widget) => (
        <DashboardWidgetCard
          dashboardFilter={dashboard.filter}
          dateRange={dateRange}
          key={widget.widgetId}
          title={dashboard.name?.trim() || t('Hustle')}
          widget={widget}
        />
      ))}
    </Stack>
  )
}
